import { LocationContext } from "@freightsimple/generated-dashboard-openapi-client/models/LocationContext";
import { LocationType } from "@freightsimple/generated-dashboard-openapi-client/models/LocationType";
import { getDistributionWareHouseRequiresDeliveryDeadline } from "@/Data/getDistributionWareHouseRequiresDeliveryDeadline";
import type { AddLocationLocationType } from "@/Shared/Types/locationTypes";

/**
 * Whether this end of the shipment must carry a deadline, rather than merely being
 * allowed one.
 *
 * Deliveries only. A deadline on a pickup is the last free day, which is genuinely
 * optional — only the delivery date is the one the warehouse holds the freight to.
 * Always narrower than `bookShipmentShouldShowDeadlineSection`: required implies shown.
 */
export function bookShipmentDeadlineIsRequired(
  location: AddLocationLocationType,
  context: LocationContext,
): boolean {
  return (
    context === LocationContext.Delivery &&
    location.locationType === LocationType.DistributionWarehouse &&
    getDistributionWareHouseRequiresDeliveryDeadline(
      location.distributionWarehouseBrand,
    )
  );
}
